export default __webpack_public_path__ + "static/media/lv.1e70815a.svg";